import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { BUTTON_VARIANTS } from "./constants";

export const buttonDataSchema = z.object({
  type: z.enum(["button", "submit", "reset"]).default("button"),
  variant: z.enum(BUTTON_VARIANTS).optional(),
  size: z.enum(SIZES).optional(),
  label: z.string().optional(),
  icon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown before the label."),
  href: z
    .string()
    .optional()
    .describe("Renders the button as a link pointing at this URL."),
  target: z
    .string()
    .optional()
    .describe("Browsing context for `href`, e.g. `_blank`."),
  ariaLabel: z
    .string()
    .optional()
    .describe("Accessible name, for a button carrying only an icon."),
  iconOnly: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false")
    .describe(
      "Shows the icon alone, the label becoming the accessible name. Needs `icon`; wrap it in <rwc-tooltip> to show the label on hover.",
    ),
  disableRipple: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type ButtonDataProps = z.infer<typeof buttonDataSchema>;
